import * as Yup from "yup";

export const InterviewSchedulingSchema = Yup.object().shape({
    emailCC: Yup.array().nullable(),
    emailContent: Yup.string().nullable(),
    interviewDate: Yup.string().nullable(),
    interviewTime: Yup.string().nullable(),
    interviewLink: Yup.string().nullable(),
    bookingIframe: Yup.string().nullable(),
})